import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./i18n"; // Inicializar i18n

/* `App` NÃO pode ser importado estaticamente aqui. Ver o bloco do modo de mocks
 * logo abaixo: 25 arquivos resolvem a URL base da API em escopo de módulo, e
 * import estático é avaliado antes de qualquer linha deste arquivo rodar. */

/* Modo de mocks (`npm run start:mock`).
 *
 * Tem que ser AQUI, antes do envoltório de `fetch` logo abaixo: assim o
 * `originalFetch` capturado por ele já é o mock, e o envoltório continua
 * funcionando por cima (cabeçalho do ngrok, renovação de token, logout no 401).
 * Instalar depois passaria por cima desse comportamento e mudaria o que se está
 * validando.
 *
 * `import()` dinâmico e não estático: assim o Rolldown não inclui `src/mocks/`
 * no bundle de produção. Fixture não pode viajar junto com o app real. */
if (import.meta.env.VITE_MOCK === "1") {
  const { instalarMocks } = await import("./mocks");
  instalarMocks();
}

/* Só AGORA a árvore do app pode ser carregada.
 *
 * O ERRO QUE ISTO CORRIGE, porque ele vai tentar voltar: 25 arquivos fazem
 * `const API_BASE_URL = getApiBaseUrl()` no topo do módulo. Import estático de
 * `App` é avaliado ANTES de qualquer linha do corpo deste arquivo — então todos
 * os 25 congelavam a base vazia antes de o mock trocá-la, as chamadas saíam
 * relativas (`/users/login`), escapavam da interceptação e batiam no servidor do
 * Vite, que responde 404. O sintoma era "login dá 404 com o e-mail de teste", e
 * não apontava para lugar nenhum perto da causa.
 *
 * `import()` dinâmico dá a garantia de ordem que o import estático não dá. */
const { default: App } = await import("./App");

// Interceptar fetch globalmente para adicionar header do ngrok
const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const { headers = {}, ...restOptions } = options;

  // Adicionar header para pular página de aviso do ngrok
  const mergedHeaders = {
    "ngrok-skip-browser-warning": "true",
    ...headers,
  };

  /* Renovação silenciosa do JWT grava o token novo só no localStorage (evita loop
   * de re-renders em useEffect([token])). Requisições devem usar sempre o Bearer atual. */
  try {
    const stored = localStorage.getItem("ikaro_auth_token");
    if (
      stored &&
      mergedHeaders.Authorization &&
      String(mergedHeaders.Authorization).toLowerCase().startsWith("bearer ")
    ) {
      mergedHeaders.Authorization = `Bearer ${stored}`;
    }
  } catch {
    /* ignore */
  }

  const hadAuthHeader =
    !!mergedHeaders?.Authorization &&
    String(mergedHeaders.Authorization).toLowerCase().startsWith("bearer ");

  return originalFetch(url, {
    ...restOptions,
    headers: mergedHeaders,
  }).then((response) => {
    try {
      const renewed = response.headers?.get?.("X-Renewed-Token");
      if (renewed && typeof window.__IKARO_AUTH_UPDATE_TOKEN__ === "function") {
        window.__IKARO_AUTH_UPDATE_TOKEN__(renewed);
      }

      if (
        hadAuthHeader &&
        response.status === 401 &&
        typeof window.__IKARO_AUTH_LOGOUT__ === "function"
      ) {
        window.__IKARO_AUTH_LOGOUT__();
      }
    } catch {
      // ignora falhas de leitura de headers / hooks
    }
    return response;
  });
};

/* React 18: `createRoot` no lugar de `ReactDOM.render`.
 *
 * Não é troca cosmética — é o que liga o renderizador concorrente. Com
 * `ReactDOM.render` o React 18 roda em modo de compatibilidade e avisa no
 * console a cada carga.
 *
 * StrictMode ligado: MUI v9 + Emotion sobrevivem ao ciclo dobrado de
 * desenvolvimento. Avisos daqui pra frente são do nosso código. */
const raiz = ReactDOM.createRoot(document.getElementById("root"));
raiz.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
